// User-visible app release history, rendered on the About page changelog.
// Newest release first. Keys live in the 'about' namespace of src/translations/*.json
// (en + es both required). Keep this in sync with docs/RELEASE_NOTES.md — the
// "What's New" store copy is the source for each release's entries.
// scripts/bump-version.sh --check verifies the newest version here matches package.json.

export interface ReleaseEntry {
  version: string;      // marketing version, e.g. '1.3.0'
  dateKey: string;      // i18n key for the release date, e.g. 'rel130Date'
  entryKeys: string[];  // i18n keys for the bullet list of user-facing changes
}

export const RELEASE_HISTORY: ReleaseEntry[] = [
  {
    version: '1.3.1',
    dateKey: 'rel131Date',
    entryKeys: ['rel131Platform', 'rel131Google']
  },
  {
    version: '1.3.0',
    dateKey: 'rel130Date',
    entryKeys: ['rel130Login', 'rel130Report', 'rel130Details']
  },
  {
    version: '1.2.2',
    dateKey: 'rel122Date',
    entryKeys: ['rel122Guided', 'rel122Capture', 'rel122Upload', 'rel122Tos', 'rel122Phi']
  },
  {
    version: '1.2',
    dateKey: 'rel12Date',
    entryKeys: ['sep25']
  },
  {
    version: '1.1',
    dateKey: 'rel11Date',
    entryKeys: ['rel11Delete', 'rel11Push', 'rel11Admin']
  },
  {
    version: '1.0',
    dateKey: 'june23',
    entryKeys: ['release']
  }
];
